<template>
    <div class="modal modal-confirm fade" id="cancelConfirmModal" tabindex="-1" role="dialog" aria-labelledby="cancelConfirmModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure you want to cancel your plan?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-footer">
                    <a class="btn btn-transparent mr-5" data-dismiss="modal" aria-label="Close">No</a>
                    <a href="javascript:void(0)" class="btn" @click="$emit('cancel-subscription')">Yes</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SubscriptionCancelModal",
        emits: ['cancel-subscription']
    }
</script>
